import { render, staticRenderFns } from "./addScrapProducts.vue?vue&type=template&id=6b78e3c8&"
import script from "./addScrapProducts.vue?vue&type=script&lang=js&"
export * from "./addScrapProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports